/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FilterExpression } from '../models/filter-expression';
import { NewStatisticQuery } from '../models/new-statistic-query';
import { StatisticQuery } from '../models/statistic-query';
import { StatisticQueryDto } from '../models/statistic-query-dto';
import { StatisticQueryPartialExcludingId } from '../models/statistic-query-partial-excluding-id';
import { StatisticQueryResult } from '../models/statistic-query-result';
import { StatisticQueryWithRelations } from '../models/statistic-query-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class StatisticQueryControllerService extends DataBaseService {

  /**
   * Path part for operation statisticQueryControllerCount
   */
  static readonly StatisticQueryControllerCountPath = '/v1/entities/{entity}/statistic-queries/count';

  /**
   * Count statistic queries that belongs to a specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count statistic queries that belongs to a specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation statisticQueryControllerFindById
   */
  static readonly StatisticQueryControllerFindByIdPath = '/v1/entities/{entity}/statistic-queries/{id}';

  /**
   * Get statistic query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<StatisticQueryWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatisticQueryWithRelations>;
      })
    );
  }
  /**
   * Get statistic query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StatisticQueryWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<StatisticQueryWithRelations>) => r.body as StatisticQueryWithRelations)
    );
  }

  /**
   * Path part for operation statisticQueryControllerDeleteById
   */
  static readonly StatisticQueryControllerDeleteByIdPath = '/v1/entities/{entity}/statistic-queries/{id}';

  /**
   * Delete statistic query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete statistic query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation statisticQueryControllerUpdateById
   */
  static readonly StatisticQueryControllerUpdateByIdPath = '/v1/entities/{entity}/statistic-queries/{id}';

  /**
   * Update statistic query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: StatisticQueryPartialExcludingId
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update statistic query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: StatisticQueryPartialExcludingId
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation statisticQueryControllerFind
   */
  static readonly StatisticQueryControllerFindPath = '/v1/entities/{entity}/statistic-queries';

  /**
   * List statistic queries that belongs to a specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<StatisticQueryWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StatisticQueryWithRelations>>;
      })
    );
  }
  /**
   * List statistic queries that belongs to a specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<StatisticQueryWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StatisticQueryWithRelations>>) => r.body as Array<StatisticQueryWithRelations>)
    );
  }

  /**
   * Path part for operation statisticQueryControllerCreate
   */
  static readonly StatisticQueryControllerCreatePath = '/v1/entities/{entity}/statistic-queries';

  /**
   * Create new statistic query for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewStatisticQuery
  }): Observable<StrictHttpResponse<StatisticQuery>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatisticQuery>;
      })
    );
  }
  /**
   * Create new statistic query for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewStatisticQuery
  }): Observable<StatisticQuery> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<StatisticQuery>) => r.body as StatisticQuery)
    );
  }

  /**
   * Path part for operation statisticQueryControllerFindByIdWithoutEntity
   */
  static readonly StatisticQueryControllerFindByIdWithoutEntityPath = '/v1/statistic-queries/{id}';

  /**
   * Get statistic query by id without entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdWithoutEntity()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdWithoutEntity$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<StatisticQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerFindByIdWithoutEntityPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatisticQueryDto>;
      })
    );
  }
  /**
   * Get statistic query by id without entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdWithoutEntity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdWithoutEntity(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StatisticQueryDto> {

    return this.findByIdWithoutEntity$Response(params).pipe(
      map((r: StrictHttpResponse<StatisticQueryDto>) => r.body as StatisticQueryDto)
    );
  }

  /**
   * Path part for operation statisticQueryControllerExecuteStatisticQueryV2
   */
  static readonly StatisticQueryControllerExecuteStatisticQueryV2Path = '/v2/entities/{entity}/statistic-queries/{id}/execute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeStatisticQueryV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeStatisticQueryV2$Response(params: {
    entity: string;
    id: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<{
'result'?: Array<StatisticQueryResult>;
'count'?: number;
'query'?: null | FilterExpression;
'hash'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, StatisticQueryControllerService.StatisticQueryControllerExecuteStatisticQueryV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'result'?: Array<StatisticQueryResult>;
        'count'?: number;
        'query'?: null | FilterExpression;
        'hash'?: string;
        }>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeStatisticQueryV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeStatisticQueryV2(params: {
    entity: string;
    id: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<{
'result'?: Array<StatisticQueryResult>;
'count'?: number;
'query'?: null | FilterExpression;
'hash'?: string;
}> {

    return this.executeStatisticQueryV2$Response(params).pipe(
      map((r: StrictHttpResponse<{
'result'?: Array<StatisticQueryResult>;
'count'?: number;
'query'?: null | FilterExpression;
'hash'?: string;
}>) => r.body as {
'result'?: Array<StatisticQueryResult>;
'count'?: number;
'query'?: null | FilterExpression;
'hash'?: string;
})
    );
  }

}
